module.exports = __webpack_public_path__ + "img/gotfertomi-coussins-1.93e73281.jpg";